var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 79,
    viewBox: "0 0 76 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.0871 79L36.4448 77.047C19.1316 56.1125 8.11414 41.8306 3.18708 30.8446C-3.9298 14.9759 2.63964 7.65188 5.85592 5.27158C11.3989 1.06027 20.0212 0.816197 27.3434 4.72234C32.3389 7.40781 36.1026 12.6567 38.3609 17.9666C45.0672 3.50164 54.9213 -0.892739 62.3803 0.144829C70.3184 1.1824 75.9298 7.95711 75.9982 16.6239C76.2035 35.6663 58.6166 55.6852 43.0826 73.3239L38.0871 79ZM16.4628 5.57675C13.4518 5.57675 10.6461 6.37018 8.52472 8.01808C3.2555 11.9853 2.70804 19.7976 7.01922 29.4409C11.6726 39.7555 21.9373 53.2439 38.1556 72.8967L39.7979 71.0046C54.1686 54.7087 72.0292 34.3846 71.8239 16.6239C71.7554 9.84915 67.5811 4.53918 61.7644 3.74574C55.4003 2.89127 45.8884 7.83501 40.0717 24.3751L37.6766 31.2108L36.1026 24.1919C34.8024 18.4548 30.8334 10.8867 25.1536 7.83503C22.3479 6.37022 19.3369 5.57675 16.4628 5.57675Z",
    fill: "#3CCFB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.330924d424dc106d410bedcd6f8a5ef8.svg";
export { ForwardRef as ReactComponent };